import { Store } from '@tanstack/store';
import {
  NotificationState
} from "@/types";

export const notificationStore = new Store<NotificationState>({
  title: null,
  description: null,
  severity: 'info',
  duration: 3000,
});

export const showToast = (title: string, description: string, severity: 'error' | 'warning' | 'info' | 'success', duration: number = 3000) => {
  notificationStore.setState((state) => ({
    ...state,
    title,
    description,
    severity,
    duration,
  }));
};

export const clearToast = () => {
  notificationStore.setState((state) => ({
    ...state,
    title: null,
    description: null,
    severity: 'info',
    duration: 3000,
  }));
};